module.exports = __webpack_public_path__ + "static/media/messy-paper-light.9b2f041a.png";